import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import {
  reportDoorState,
  reportFilterGroupState,
  reportSearchTypeState,
  reportViewState,
} from '../../../storage/reports';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import DoorStateReports from '../../reports/doorStateReport/DoorStateReports';
import DoorStateReportsByGroup from '../../reports/doorStateReport/DoorStateReportsByGroup';
import ReportsSharedWrapper from './ReportsSharedWrapper';

function DoorReportsPage() {
  const { theme } = useStyles();
  const reportView = useRecoilValue(reportViewState);
  const reportSearchType = useRecoilValue(reportSearchTypeState);
  const groupId = useRecoilValue(reportFilterGroupState);
  const hasStates = !!useRecoilValue(reportDoorState(groupId))?.length;
  const isGroupReportView = reportSearchType === 1 && reportView === 0;

  return (
    <FloatingCardsLayout
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
        >
          <ReportsSharedWrapper>
            {!isGroupReportView && <DoorStateReports />}
            {isGroupReportView && <DoorStateReportsByGroup />}
          </ReportsSharedWrapper>
        </FloatingCardContent>
      }
      contentSize={isGroupReportView && hasStates ? 800 : 550}
    />
  );
}

export default DoorReportsPage;
